import create from 'zustand'
import { withImmer, logger } from 'utils/store'
import {
  createLiveTrackingTruckSlice,
  type LiveTrackingTruckSlice,
} from './liveTrackingTruckSlice'

const useLiveTrackingTruckStore = create<LiveTrackingTruckSlice>(
  logger(withImmer(createLiveTrackingTruckSlice), 'TruckStore'),
)

export { useLiveTrackingTruckStore }
export type { LiveTrackingTruckSlice }
